import React, { useState } from "react";

import { useSoilSightCurrency, useTranslation } from "utils";

import { Button, Icon } from "components";

import { BookingModal } from "pages/app/scenario-analysis/components/BookingModal";

export const AgronomyUpsellPanel = () => {
  const { t } = useTranslation("scenarioAnalysis");
  const { currencySymbol, isZloty } = useSoilSightCurrency();
  const consultationPrice = isZloty ? 419 : 99;
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="agronomy-upsell-panel">
        <div
          className="agronomy-upsell-image"
          aria-hidden="true"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/scenario-analysis/agronomy-upsell.jpg)` }}
        />

        <div className="agronomy-upsell-body">
          <div className="agronomy-upsell-meta">
            <div className="agronomy-upsell-meta-left">
              <span className="agronomy-upsell-badge">{t("upsell.badge")}</span>
              <span className="agronomy-upsell-title">{t("upsell.title")}</span>
            </div>
            <div className="agronomy-upsell-pricing">
              <span className="agronomy-upsell-price">{`${consultationPrice}${currencySymbol}`}</span>
              <span className="agronomy-upsell-duration">{t("upsell.duration")}</span>
            </div>
          </div>

          <span className="agronomy-upsell-description">{t("upsell.description")}</span>

          <Button type="primary" className="agronomy-upsell-cta" onClick={() => setIsModalOpen(true)}>
            {t("upsell.cta")}
            <Icon iconName="tabler/arrow-right" size="s" className="agronomy-upsell-cta-icon" />
          </Button>
        </div>
      </div>

      <BookingModal isVisible={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default AgronomyUpsellPanel;
